import * as types from './mutations-types'

export default {
  [types.MY_POINTS_LIST] (state, data) {
    console.log(data)
    state.myPointsList = data.dataList
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-points/store/mutations.js